export default __webpack_public_path__ + "static/media/3.ee5b7688.png";